import { Injectable } from '@angular/core';
import {BehaviorSubject, fromEvent, Observable, Subject} from "rxjs";
import {filter} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class DomEventsService {

  private _sidebarState$ = new BehaviorSubject(false);
  private _currentHiddenMenuUpdated$:Subject<any> = new Subject<any>();

  private _currentActiveAdditionalMenuElement = null;

  private _isClickDisabled = false;
  set isClickDisabled(val){
    this._isClickDisabled = val;
  }

  set currentActiveAdditionalMenuElement(val){
    this._currentActiveAdditionalMenuElement = val;
  }

  get currentActiveAdditionalMenuElement(){
    return this._currentActiveAdditionalMenuElement;
  }

  get sidebarState$(){
    return this._sidebarState$.asObservable()
  }

  set sidebarState$(val:any){
    this._sidebarState$.next(val);
  }

  get currentHiddenMenuUpdated$():any{
    return this._currentHiddenMenuUpdated$.asObservable()
  }

  set currentHiddenMenuUpdated$(val:any){
    this._currentHiddenMenuUpdated$.next(val);
  }

  constructor() {
    this.initListeners();
  }

  private initListeners(){
    fromEvent(window, 'click').pipe(filter(val => !this._isClickDisabled)).subscribe((event)=>{
      if (!this._currentActiveAdditionalMenuElement || !this._currentActiveAdditionalMenuElement.nativeElement.contains(event.target)){
          this._currentHiddenMenuUpdated$.next({item: null, type: null});
      }
    })
  }
}
